// src/analytics.js
export const initGA = () => {
  if (!window.gtag) {
    // Load GA script
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-YC16PJ7M8H";
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-YC16PJ7M8H');
    `;
    document.head.appendChild(script2);
  }
};

export const logEvent = (action, params) => {
  if (window.gtag) {
    window.gtag("event", action, params);
  }
};
